import { useState } from "react";
import { Link } from "react-router-dom";
import { Layout, Menu, Drawer, Button, Grid } from "antd";
import {
  HomeOutlined,
  PhoneOutlined,
  CreditCardOutlined,
  BarcodeOutlined,
  TrophyOutlined,
  MenuOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import logo from "../../../assets/images/Logo-Rifas-Gran-Familia.png";

import "./Navbar.css";

const { Header } = Layout;
const { useBreakpoint } = Grid;

export default function Navbar() {
  const [visible, setVisible] = useState(false);
  const screens = useBreakpoint();

  const menuItems = [
    {
      key: "inicio",
      icon: <HomeOutlined />,
      label: <Link to="/">Inicio</Link>,
    },
    {
      key: "contacto",
      icon: <PhoneOutlined />,
      label: <Link to="/#contacto">Contacto</Link>,
    },
    {
      key: "metodos",
      icon: <CreditCardOutlined />,
      label: <Link to="/pagos">Métodos de Pago</Link>,
    },
    {
      key: "boletos",
      icon: <BarcodeOutlined />,
      label: <Link to="/boletos">Boletos</Link>,
    },
    {
      key: "verificador",
      icon: <SafetyCertificateOutlined />,
      label: <Link to="/verificador">Verificador</Link>,
    },
    {
      key: "ganadores",
      icon: <TrophyOutlined />,
      label: <Link to="/ganadores">Ganadores</Link>,
    },
  ];

  return (
    <Header className="navbar-gen-header">
      <div>
        <Link className="navbar-gen-link" to="/">
          <img
            src={logo}
            alt="Rifas Gran Familia GDL"
            className="navbar-gen-logo"
          />
        </Link>

        {screens.lg ? (
          <Menu
            mode="horizontal"
            items={menuItems}
            className="navbar-gen-menu"
          />
        ) : (
          <div style={{ position: "absolute", right: 0 }}>
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setVisible(true)}
            />
            <Drawer
              title="Menú"
              placement="right"
              onClose={() => setVisible(false)}
              open={visible}
            >
              <Menu
                mode="vertical"
                items={menuItems}
                onClick={() => setVisible(false)}
              />
            </Drawer>
          </div>
        )}
      </div>
    </Header>
  );
}
